// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__4yXjl","time":"styles_time__3Pj56"};